import { Avatar, Box, IconButton, Tooltip, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import TableContainer from "../../Components/TableContainer";
import AxiosInstance from "../../Config/AxiosInstance";
import { ApiList } from "../../Config/ApiList";
import useDebounce from "../../Components/useDebounce";
import CustomSearchBox from "../../Components/CustomSearch";
import DummyUser from "../../Assets/User.webp";
import { useNavigate } from "react-router-dom";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
const ReportUsers = () => {
  const pageSize = 15;
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const [totalData, setTotalData] = useState(0);
  const debouncedSearch = useDebounce(search, 500);
  const handlePageChange = (newValue) => {
    setPage(newValue);
  };
  const getReportedUserList = async () => {
    setLoading(true);
    try {
      const response = await AxiosInstance.get(ApiList.GET_REPORTED_USERS, {
        params: {
          count: page * pageSize,
          search: debouncedSearch,
        },
      });
      if (response?.data?.s === 1) {
        const formattedUsers = response?.data?.r?.map((user, index) => ({
          rowid: index + 1 + page * pageSize,
          ...user,
        }));
        setData(formattedUsers);
        setTotalData(response?.data?.c);
      } else {
        setData([]);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  const columns = [
    {
      field: "rowid",
      headerName: "Sr.No",
      width: 80,
      align: "center",
      align: "center",
      headerAlign: "center",
    },
    {
      field: "image",
      headerName: "Profile",
      width: 100,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <Avatar
          sx={{
            width: "40px",
            height: "40px",
            objectFit: "contain",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            src={
              params?.row?.image
                ?`${ApiList.IMG_URL}${params?.row?.image}`
                : DummyUser
            }
            style={{ width: "100%", height: "100%" }}
          ></img>
        </Avatar>
      ),
    },
    {
      field: "name",
      headerName: "Reported User",
      flex: 1,
      minWidth: 200,
      headerClassName: "leftAlignHeader",
      cellClassName: "leftAlign",
      renderCell: (params) => {
        const name = `${params?.row?.fname || ""} ${params?.row?.lname || ""}`;
        const truncatedCaption =
          name?.length > 20 ? `${name.substring(0, 20)}...` : name;
        return (
          <Tooltip title={`${params?.row?.fname} ${params?.row?.lname}`}>
            {truncatedCaption}
          </Tooltip>
        );
      },
    },
    {
      field: "reported_count",
      headerName: "Reported Count",
      flex: 1,
      minWidth: 100,
      headerClassName: "leftAlignHeader",
      cellClassName: "center",
    },
    {
      field: "email",
      headerName: "Email",
      flex: 1,
      minWidth: 200,
      headerClassName: "leftAlignHeader",
      cellClassName: "leftAlign",
      renderCell: (params) => {
        const email = params.row.email;
        const truncatedCaption =
          email?.length > 20 ? `${email.substring(0, 20)}...` : email;
        return <Tooltip title={params?.row?.email}>{truncatedCaption}</Tooltip>;
      },
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      minWidth: 200,
      cellClassName: "Center",
      renderCell: (params) => {
        return (
          <Typography
            sx={{
              borderRadius: "10px",
              width: "100px",
              background: params?.row?.status === 1 ? "#b9cc03" : "red",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              p: 1,
              fontWeight:"300",
              fontSize:"14px"
            }}
          >
            {params?.row?.status === 1 ? "Unblocked" : "Blocked"}
          </Typography>
        );
      },
    },
    {
      field: "Action",
      headerName: "Action",
      width: 100,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return (
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "space-evenly",
            }}
          >
            <IconButton
              onClick={() =>
                navigate("/report-user/report-user-details", {
                  state: {
                    id: params?.row?.report_to,
                    user: params?.row,
                  },
                })
              }
            >
              <RemoveRedEyeIcon sx={{ color: "#b9cc03" }} />
            </IconButton>
          </Box>
        );
      },
    },
  ];
  useEffect(() => {
    getReportedUserList();
  }, [debouncedSearch,page]);
  return (
    <>
      <Box
        sx={{
          width: "100%",
          height: "100vh",
          background: "#B9CC0310",
          overflow: "hidden",
        }}
      >
        <Box sx={{ width: "100%", p: 2, background: "#B9CC0310" }}>
          <Typography
            sx={{
              fontSize: { xs: "18px", md: "28px" },
              fontWeight: "300",
              color: "#000",
            }}
          >
            Reported User
          </Typography>
        </Box>
        <Box sx={{ width: "100%", p: 2 }}>
          <Box sx={{ width: "400px" }}>
            <CustomSearchBox
              placeholder={"Search"}
              onChange={(e) => setSearch(e?.target?.value)}
              onClear={() => setSearch("")}
            />
          </Box>
        </Box>
        <Box sx={{ width: "100%", height: "calc(100vh - 158.67px)", p: 2 }}>
          <TableContainer
            columns={columns}
            rows={data}
            handlePageChange={handlePageChange}
            page={page}
            loading={loading}
            totalData={totalData}
            pageSize={pageSize}
          />
        </Box>
      </Box>
    </>
  );
};

export default ReportUsers;
